import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { createSelector } from '@ngrx/store';

import { WindowRef } from '../shared/services/window-ref';
import { getSelectedLanguage } from '../shared/state-management/reducers';
import { WebstartService } from '../shared/webstart/webstart.service';

const langToNEOLangMapping: {[key: string]: string} = {
	'DEFAULT': 'de_DE',
	'de': 'de_DE',
	'en': 'en_US',
	'pl': 'pl_PL',
	'hr': 'hr_HR',
	'nl': 'nl_NL',
	'st': 'rs_RS',
	'cs': 'cz_CZ',
	'tr': 'tr_TR',
	'ro': 'ro_RO',
	'fr': 'fr_FR',
	'sl': 'sl_SL',
	'hu': 'hu_HU',
	'ru': 'ru_RU',
	'es': 'es_ES',
	'bg': 'bg_BG',
};


@Injectable()
export class NeoFrameService {
	public static getSelectedNEOLanguage = createSelector(getSelectedLanguage, (lang) => {
		return langToNEOLangMapping[lang] || langToNEOLangMapping['DEFAULT'];
	});

	private _externalWindowActive = new BehaviorSubject(false);

	public windowRef: null | Window = null;
	public externalWindowActive$ = this._externalWindowActive.asObservable();

	public reloadNeoFrame$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor(
		private window: WindowRef,
		private webstart: WebstartService
	) {
		window.nativeWindow.addEventListener('message',  ({data}) => {
			if (data === 'neo:ready') {
				this._externalWindowActive.next(true);
			}
		});
	}

	public openInNewWindow() {
		if (this.windowRef) {
			this.windowRef.focus();
			return;
		}

		this.webstart.getWebstartForSelectedAgent('neo').take(1).subscribe(webstart => {
			if (webstart) {
				const win = this.window.nativeWindow.open(webstart.url);
				this.setNEOWindowRef(win);
				win.focus();
			}
		}).unsubscribe();
	}

	public setNEOWindowRef(win: Window) {
		this.windowRef = win;
		let intervalId;

		const listener = () => {
			if (!this.windowRef || !this.windowRef.window || (this.windowRef && this.windowRef.closed)) {
				this.windowRef = null;
				this._externalWindowActive.next(false);
				clearInterval(intervalId);
			}
		};

		intervalId = setInterval(listener, 250);
	}
}



// WEBPACK FOOTER //
// ./src/app/neo-frame/neo-frame.service.ts